export default "__VITE_ASSET__BPvFGJ$i__"